import { Button, Form } from 'antd';
import React from 'react'

export function RegistrationFormButton({
    profileSomethingChanged, 
    myRegistraton, 
    somethingChanged,
    isUpdating
}) {

    function checkRegisterButtonDisabled() {
        if(isUpdating) {
            return true;
        }

        if(profileSomethingChanged) {
            return true;
        }

        if(myRegistraton == null) {
            return false;
        }

        return !somethingChanged
    }

    return (
        <Form.Item >
            {profileSomethingChanged && <p>Please update the profile first</p>}
            <Button 
                type="primary" 
                htmlType="submit"
                disabled={checkRegisterButtonDisabled()}
            >
            {myRegistraton === null ? 'Register for event': 'Update registration'}
            </Button>
        </Form.Item>
    )
}